module.exports = __webpack_public_path__ + "img/pole-status-red.a46d6c1e.webp";